import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import { isLoginError, loginWithSession } from 'shared/api/sessionAuth';

import Layout from 'layouts/member/Layout';

import TextBox from 'components/TextBox';
import PasswordBox from 'components/PasswordBox';
import SubmitButton from 'components/SubmitButton';

import logo from 'assets/common/icons/logo_m.png';


const Login: React.FC = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const [loginId, setLoginId] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [, setLoading] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    if (!loginId || !password) {
      setError(t('messages.errors.requiredLogin'));
      return;
    }
    setLoading(true);
    try {
      const result = await loginWithSession(loginId, password, 'member');
      if (isLoginError(result)) {
        setError(t('messages.errors.invalidLogin'));
        return;
      }
      navigate('/');
    } catch {
      setError(t('messages.errors.networkError'));
    } finally {
      setLoading(false);
    }
  };

  return (
    <Layout>
      <div className="flex items-center justify-center min-h-screen bg-gray-50">
        <div className="flex flex-col items-center w-full max-w-md px-8 py-10 bg-white shadow-xl rounded-2xl">
          <img src={logo} alt="Goodrescue24" className="h-24 mb-4" />
          <form className="w-full" onSubmit={handleSubmit}>
            {error && (
              <div className="mb-4 text-sm text-center text-red-600">{error}</div>
            )}
            <div className="mb-5">
              <TextBox
                id="loginId"
                value={loginId}
                label={t('pages.member.login.loginId')}
                onChange={e => setLoginId(e.target.value)}
                labelClass="text-gray-600"
                className="w-full px-4 py-2 bg-white border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-primary"
                isBaseClass={false}
                autoComplete="on"
              />
            </div>
            <div className="mb-7">
              <PasswordBox
                id="password"
                value={password}
                label={t('pages.member.login.password')}
                onChange={e => setPassword(e.target.value)}
                labelClass="text-gray-600"
                className="w-full px-4 py-2 bg-white border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-primary"
                isBaseClass={false}
              />
            </div>
            <SubmitButton
              className="w-full py-3 mb-3 text-base font-semibold text-white transition-colors duration-150 rounded-lg shadow"
              color={{ normal: 'bg-primary hover:bg-accent' }}
              disabled={!loginId || !password}
            >
              {t('pages.member.login.submit')}
            </SubmitButton>
            <div className="text-center">
              <a href="#" className="text-sm font-bold text-text-primary hover:underline">
                {t('pages.member.login.supporterLogin')}
              </a>
              <br />
              <br />
              <a href="#" className="text-sm text-secondary hover:underline">
                {t('pages.member.login.registerHere')}
              </a>
              <br />
              <a href="#" className="text-sm text-secondary hover:underline">
                {t('pages.member.login.forgotPassword')}
              </a>
            </div>
          </form>
        </div>
      </div>
    </Layout>
  );
};

export default Login;
